import { IsNotEmpty, IsString } from 'class-validator';

export class MctReferenceFirmwareDto
{
    @IsString()
    @IsNotEmpty()
    version!: string;
}